<template>
  <div
    v-if="props.visible"
    class="i-base-modal"
    :style="{
      'z-index': props.zIndex
    }"
  >
    <div
      class="outer-wrapper"
      :style="{
        'min-width': props.minWidth,
        'max-width': props.maxWidth
      }"
    >
      <button
        v-if="props.showCloseIcon"
        class="close-modal"
        :class="{ regular: !props.useLightCloseIcon }"
        @click="clickOnClose"
      >
        <img
          :src="props.useLightCloseIcon ? iconCloseButtonLight : iconCloseButtonBlack"
          loading="lazy"
          alt="Close"
          class="close-modal-icon"
        />
      </button>

      <div :class="{ 'message-container': !props.fullyCustomisable }">
        <div :class="{ 'inner-wrapper': !props.fullyCustomisable }">
          <div :class="{ content: !props.fullyCustomisable }">
            <slot></slot>
          </div>
        </div>
      </div>
    </div>
    <div
      class="shade"
      @click="props.enableBgClose ? clickOnClose() : null"
    ></div>
  </div>
</template>

<script setup lang="ts">
import { zIndexModal } from "@/styles/variables"

import iconCloseButtonBlack from "@/assets/buttons/close-button-black.svg"
import iconCloseButtonLight from "@/assets/icons/icon-light-grey-close.svg"

const emit = defineEmits(["clickOnClose"])

// Props

const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  minWidth: {
    type: String,
    default: "220px"
  },
  maxWidth: {
    type: String,
    default: "680px"
  },
  zIndex: {
    type: Number,
    default: zIndexModal
  },
  fullyCustomisable: {
    type: Boolean,
    default: false
  },
  showCloseIcon: {
    type: Boolean,
    default: true
  },
  enableBgClose: {
    type: Boolean,
    default: false
  },
  useLightCloseIcon: {
    type: Boolean,
    default: false
  }
})

// Functions

function clickOnClose() {
  emit("clickOnClose")
}
</script>

<style lang="scss" scoped>
.i-base-modal {
  position: fixed;
  overflow-y: auto;
  inset: 0%;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  background-color: rgba($pickle-bluewood950, 0.96);
  height: 100lvh;
  padding: 25px 0;

  @media screen and (min-width: $breakpoint-md) {
    padding: unset;
  }

  .shade {
    position: absolute;
    background-color: transparent;
    width: 100%;
    height: 100%;
    z-index: $z-index-background;
  }

  .outer-wrapper {
    position: relative;
    width: 90%;
    height: auto;
    margin: auto;
    border-radius: 16px;
    background-color: #fff;

    .close-modal {
      position: absolute;
      inset: 10px 10px auto auto;
      z-index: $z-index-modal + $z-index-above;
      padding: 4px;
      border-radius: 32px;
      background-color: transparent;
      cursor: pointer;

      &.regular {
        background-color: #e8e8e8;
        box-shadow: 0 2px 5px 0 rgb(0 0 0 / 20%);
        transition: background-color 200ms ease;

        &:hover {
          background-color: #b3b3b3;
        }
      }
    }

    .close-modal-icon {
      width: 20px;
      height: 20px;
    }

    .message-container {
      display: flex;
      width: 95%;
      max-width: 1498px;
      margin-right: auto;
      margin-left: auto;
      flex-direction: column;
      justify-content: center;

      .inner-wrapper {
        text-align: center;
        position: relative;
        z-index: $z-index-modal;
        padding-top: 3%;
        padding-bottom: 3%;

        .content {
          margin-top: 16px;
          margin-bottom: 16px;
        }
      }
    }
  }
}

@media screen and (min-width: $breakpoint-md) {
  .i-base-modal {
    .close-modal {
      top: 8px;
      right: 8px;
    }

    .content {
      margin-top: 24px;
      margin-bottom: 24px;
    }
  }
}
</style>
